import { Close } from '@mui/icons-material';
import {
    Box,
    IconButton,
    Popover,
    Stack,
    Typography,
    CircularProgress,
} from '@mui/material';
import ContactCard from '../Pages/ConstructionQuality/RepairRequestContactCard';
import { useTranslation } from 'react-i18next';


const BuyerContactPopover = ({ anchorEl, onClose, loading, data }) => {
    const { t } = useTranslation();
    const open = Boolean(anchorEl);
    const buyerInfoPopoverId = open ? `buyerInfo-popover` : undefined;

    return (
        <Popover
            id={buyerInfoPopoverId}
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}

        >
            <Box sx={{ p: 2, width: 400 }}>
                <Stack mb={1} direction="row" justifyContent="space-between" alignItems="center">
                    <Typography fontWeight="bold">{t('buyersGuide.buyersInfo')}</Typography>
                    <IconButton size="small" onClick={onClose}>
                        <Close fontSize="small" />
                    </IconButton>
                </Stack>

                {loading ? (
                    <Stack direction={'row'} justifyContent={'center'}>
                        <CircularProgress size={18} />
                    </Stack>
                ) : (
                    data ? (
                        <>
                            {data.type === 0 && (
                                <>
                                    <Box mb={1}>
                                        <ContactCard
                                            hidePointOfContactCheckbox
                                            object={data.p1}
                                            subTitle={t("general.buyer1")}
                                        />
                                    </Box>
                                    {data.p2 && (
                                        <ContactCard
                                            hidePointOfContactCheckbox
                                            object={data.p2}
                                            subTitle={t("general.buyer2")}
                                        />
                                    )}
                                </>
                            )}
                            {data.type === 1 && (
                                <ContactCard
                                    hidePointOfContactCheckbox
                                    object={data.org}
                                    isOrg
                                    subTitle={t("general.buyerOrganization")}
                                />
                            )}
                        </>
                    ) : <>
                        <Typography align='center' variant='body2'>{t('general.noDataFound')}</Typography>
                    </>
                )}
            </Box>
        </Popover>
    );
};

export default BuyerContactPopover;
